const REASONS = {
  doNotMatch: 'doNotMatch'
}
export { REASONS }


export default function areNewPasswordsValid(password, passwordRepeat) {
  //TODO this is the place to implement password requirements; length, complexity etc.

  if (password !== passwordRepeat)
    return { valid: false, reason: REASONS.doNotMatch };

  return { valid: true };
}